function copyParty(party) {
	return {
		id: party.id,
		name: party.name,
		r10Id: party.r10Id,
		street: party.street,
		country: party.country,
		postalCode: party.postalCode,
		countryCode: party.countryCode,
		postalPlace: party.postalPlace,
		latitude: party.latitude,
		longitude: party.longitude,
		contactName: party.contactName,
		contactPhone: party.contactPhone,
		contactEmail: party.contactEmail,
		customerNumber: party.customerNumber,
		marks: party.marks,
		customsCreditNumber: party.customsCreditNumber,
		voec: party.voec,
		organizationNumber: party.organizationNumber,
		exporterNumber: party.exporterNumber,
		eori: party.eori,
		website: party.website,
		vendorNumber: party.vendorNumber,
		vat: party.vat,
		gs1LocationNumber: party.gs1LocationNumber,
		...party,
	};
}

export default copyParty;